module.exports = __webpack_public_path__ + "img/icon-payments.3434e1d5.svg";